export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40592706f925e44ca64485495488d240f96e884ecc&name=revalidateCommunity!'